/* eslint-disable @typescript-eslint/no-explicit-any */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const isObject = (obj)=>obj && typeof obj === 'object';
/**
 * Deeply merge nested objects; behavior compatible with lodash.merge
 *
 * @param target
 * @param source
 * @returns
 */ export const deepMerge = (target, source)=>{
    if (!isObject(target) || !isObject(source)) {
        return source;
    }
    Object.keys(source).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            target[key] = sourceValue;
        } else if (isObject(targetValue) && isObject(sourceValue)) {
            target[key] = deepMerge(_object_spread({}, targetValue), sourceValue);
        } else {
            target[key] = sourceValue;
        }
    });
    return target;
};

//# sourceMappingURL=deepMerge.js.map